<template>
  <div class="modal fade" ref="mdlWhatsapp" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Whatsapp de <strong>{{nombreCliente}}</strong>
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p>
            Se muestran los numeros telefonicos registrados
          </p>

          <div class="table-responsive">
            <table class="table mb-0 align-middle table-nowrap">
              <thead>
                <tr>
                  <th class="text-center">Número</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="telefono in telefonos" :key="telefono.id">
                  <td>
                    <input
                      type="text"
                      class="form-control text-center"
                      :value="(telefono.prefijo != '' && telefono.prefijo != null && telefono.prefijo != 'null' ? '('+telefono.prefijo+') ' : '('+prefijo_default+') ')+telefono.numero"
                      readonly>
                  </td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center gap-2">
                      <!-- 1. Enlace externo a WhatsApp Web / App -->
                      <a 
                        :href="urlWhatsapp(telefono)"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="btn btn-success btn-sm bg-gradient d-inline-flex align-items-center"
                        :title="`Enviar a WhatsApp: ${telefono.numero}`"
                        v-show="telefono.tipo == 'celular'"
                      >
                        <i class="mdi mdi-whatsapp me-1 font-size-15"></i>
                        <span>WhatsApp</span>
                      </a>

                      <!-- 2. Navegación interna a la vista Mensajes / WhatsApp -->
                      <button 
                        type="button"
                        class="btn btn-primary btn-sm bg-gradient d-inline-flex align-items-center"
                        title="Abrir chat en el sistema"
                        v-if="telefono.tipo == 'celular' && estadoWhatsapp.activo"
                        @click="irAMensajes(telefono)"
                      >
                        <i class="mdi mdi-chat-processing-outline me-1 font-size-15"></i>
                        <span>Mensajes</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-light"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from 'bootstrap/js/dist/modal';
import SistemaSrv from '@/services/SistemaSrv.js';
import WhatsappSrv from '@/services/WhatsappSrv.js';
import { estadoWhatsapp, cargarEstadoWhatsapp } from '@/services/WhatsappEstado.js';

export default {
  name: 'MdlWhatsapp',

  data() {
    return {
      estadoWhatsapp,
      nombreCliente: '',
      telefonos: [],
      prefijo_default: '',
      idCliente: null,
      modalInstance: null
    }
  },

  methods: {
    mostrar(telefonos, nombreCliente, idCliente = null) {
      let self = this

      self.telefonos = telefonos
      self.nombreCliente = nombreCliente
      self.idCliente = idCliente

      self.cargarPrefijoTelefonico()
      cargarEstadoWhatsapp()

      self.modalInstance = new Modal(self.$refs.mdlWhatsapp)
      self.modalInstance.show()
    },

    irAMensajes(telefono = null) {
      const idTel = telefono ? (telefono.id || telefono.id_telefono_cliente) : null;
      const num = telefono ? telefono.numero : null;
      if (idTel) {
        WhatsappSrv.actualizarTelefonoCliente(idTel, { chat: 1 }).catch(() => {});
      }

      if (this.modalInstance) {
        this.modalInstance.hide()
      }
      const backdrops = document.querySelectorAll('.modal-backdrop')
      backdrops.forEach(el => el.remove())
      document.body.classList.remove('modal-open')
      document.body.style.removeProperty('overflow')
      document.body.style.removeProperty('padding-right')

      const query = {};
      if (this.idCliente) query.id_cliente = this.idCliente;
      if (idTel) query.id_telefono = idTel;
      if (num) query.numero = num;

      const params = {};
      if (this.idCliente) params.id_cliente = this.idCliente;
      if (idTel) params.id_telefono = idTel;

      this.$router.push({
        name: 'whatsappMensajes',
        params,
        query
      }).catch(() => {})
    },

    urlWhatsapp(telefono){
      var self = this
      let numero = (telefono.prefijo != '' && telefono.prefijo != null && telefono.prefijo != 'null' ? telefono.prefijo : self.prefijo_default) + ' ' + telefono.numero
      return `https://api.whatsapp.com/send/?phone=${this.whatsapp(numero)}&text=Hola ${this.nombreCliente}`
    },

    cargarPrefijoTelefonico: function() {
      var self = this

      SistemaSrv.ajustes(['prefijo_telefonico']).then(response => {
        let ajustes = response.data
        self.prefijo_default = ajustes.prefijo_telefonico
      })
    },

    whatsapp(numero) {
      let num = numero.replace(/ /g, "").toString()
      num = num.replace(/-/g, "").toString()
      return num
    },
  },
}
</script>

<style scoped>

</style>